module.exports = __webpack_public_path__ + "img/blog-3.d5e40005.jpg";